import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import CalendarDrawerPanel from '../calendar/calendarSettingPanel/calendarDrawerPanel';
import DrawerPanelListTask from '../gant/gantSettingPanel/drawerPanelListTask';
import GantDrawerPanel from '../gant/gantSettingPanel/gantDrawerPanel';
import { RootState } from '../store';
import { ItemType } from '../types';

const smxDrawerPanel = () => {
    const [startDate, endDate] = useSelector<RootState, string[]>((state) => state.gant.dayForListTaskShow);
    const scheduleItemForListTaskShow = useSelector<RootState, ItemType | null>(
        (state) => state.gant.scheduleItemForListTaskShow,
    );

    const [isRenderDrawerPanelListTask, setIsRenderDrawerPanelListTask] = useState(false);

    useEffect(() => {
        setIsRenderDrawerPanelListTask(!!(scheduleItemForListTaskShow || startDate || endDate));
    }, [scheduleItemForListTaskShow, startDate, endDate]);

    return (
        <div
            style={{
                userSelect: 'none',
                WebkitUserSelect: 'none',
                MozUserSelect: 'none',
                msUserSelect: 'none',
            }}
        >
            {!isRenderDrawerPanelListTask && (
                <>
                    <CalendarDrawerPanel />
                    <GantDrawerPanel />
                </>
            )}
            {isRenderDrawerPanelListTask && <DrawerPanelListTask />}
        </div>
    );
};

export default smxDrawerPanel;
